export default __webpack_public_path__ + "static/media/level2Wired.6d0a3edf.svg";